(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-modal-popup"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('custom-snack-popup');
    const closeBtn = popup.querySelector('.custom-snack-popup-close');
    const body = document.body;

    // Helper: Set a cookie
    function setCookie(name, value, days) {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
    }

    // Helper: Get a cookie
    function getCookie(name) {
      return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1];
    }

    // Show the popup only if the cookie is NOT set
    if (!getCookie('customSnackPopupShown')) {
      setTimeout(() => {
        popup.classList.remove('hidden');
        body.classList.add('custom-snack-popup-active');
        setCookie('customSnackPopupShown', 'true', 30); // Set cookie for 30 days
      }, 2000);
    }

    // Close popup on close button click
    closeBtn.addEventListener('click', function () {
      popup.classList.add('hidden');
      body.classList.remove('custom-snack-popup-active');
    });

    // Close popup when clicking outside content
    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        popup.classList.add('hidden');
        body.classList.remove('custom-snack-popup-active');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
